export default __webpack_public_path__ + "static/surveillance-video-2-507e101e7590a263496e33b82bb0d745.webm";